/**
 * Collection PLP: keyword search within current Convermax results.
 * Mounts to the right of the category title (#cm-collection-header)
 * and applies Convermax `filterquery`.
 */
(function () {
  var HEADER_SEL = '#cm-collection-header';
  var PAGE_SEL = '#cm-collection-page';
  var ROOT_CLASS = 'fcd-collection-filter-search';
  var ROW_CLASS = 'fcd-collection-header-row';
  var PARAM = 'filterquery';
  var mounted = false;

  function getInitialQuery() {
    try {
      return new URL(window.location.href).searchParams.get(PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  function collectionLabel() {
    var cfg = window.FCDCollectionFilterSearch || {};
    if (cfg.title) return String(cfg.title);
    var titleEl = document.querySelector(
      HEADER_SEL + ' h1.cm-collection-header__title, ' + HEADER_SEL + ' h1'
    );
    if (titleEl && titleEl.textContent) return titleEl.textContent.trim();
    return '';
  }

  function placeholderText() {
    var label = collectionLabel();
    return label ? 'Search within ' + label : 'Search within collection';
  }

  function applyFilterQuery(raw) {
    var query = String(raw || '').trim();
    var url;
    try {
      url = new URL(window.location.href);
    } catch (e) {
      return;
    }

    var current = url.searchParams.get(PARAM) || '';
    if (query === current) return;

    if (query) url.searchParams.set(PARAM, query);
    else url.searchParams.delete(PARAM);

    url.searchParams.delete('page');
    url.searchParams.delete('pagenumber');

    window.location.assign(url.pathname + url.search + url.hash);
  }

  function buildForm() {
    var form = document.createElement('form');
    form.className = ROOT_CLASS;
    form.setAttribute('role', 'search');
    form.setAttribute('data-fcd-collection-filter-search', '');

    var label = document.createElement('label');
    label.className = ROOT_CLASS + '__label';
    label.setAttribute('for', 'fcd-collection-filter-search-input');
    label.textContent = 'Search within collection';

    var wrap = document.createElement('div');
    wrap.className = ROOT_CLASS + '__field';

    var input = document.createElement('input');
    input.type = 'search';
    input.id = 'fcd-collection-filter-search-input';
    input.className = ROOT_CLASS + '__input';
    input.name = PARAM;
    input.autocomplete = 'off';
    input.placeholder = placeholderText();
    input.value = getInitialQuery();
    input.setAttribute('aria-label', placeholderText());

    var submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = ROOT_CLASS + '__submit';
    submit.setAttribute('aria-label', 'Search');
    submit.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';

    wrap.appendChild(input);
    wrap.appendChild(submit);
    form.appendChild(label);
    form.appendChild(wrap);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilterQuery(input.value);
    });

    return form;
  }

  function findHeaderHost() {
    var header = document.querySelector(HEADER_SEL + '> div.cm-collection-header__content');
    if (header) return header;

    var page = document.querySelector(PAGE_SEL);
    if (!page) return null;

    var section = page.closest('.shopify-section') || page.parentElement;
    var prev = section && section.previousElementSibling;
    if (!prev) return null;

    var h1 = prev.querySelector('h1.heading, h1');
    if (!h1) return null;

    var host = h1.closest('.container') || h1.parentElement;
    if (host && !host.id) host.id = 'cm-collection-header';
    return host;
  }

  // Subcategory carousel (when present) is its own Convermax app block,
  // a sibling that renders after the header. Insert the search form
  // right after that whole block so it sits below the carousel instead
  // of next to the title.
  function findCarouselBlock() {
    var carousel = document.querySelector('.cm_vehicle-categories__carousel');
    if (!carousel) return null;
    return carousel.closest('.shopify-block') || carousel;
  }

  function mount() {
    if (mounted) return true;
    if (document.querySelector('[data-fcd-collection-filter-search]')) {
      mounted = true;
      return true;
    }

    var carouselBlock = findCarouselBlock();
    if (carouselBlock) {
      var form = buildForm();
      form.classList.add(ROOT_CLASS + '--below-carousel');
      carouselBlock.insertAdjacentElement('afterend', form);
      mounted = true;
      return true;
    }

    var header = findHeaderHost();
    if (!header) return false;

    header.classList.add(ROW_CLASS, 'fcd-collection-header--with-search');
    header.appendChild(buildForm());
    mounted = true;
    return true;
  }

  function start() {
    if (mount()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (mount() || tries > 40) window.clearInterval(timer);
    }, 250);

    // Header mounts as a sibling of #cm-collection-page, so watch a shared ancestor.
    var page = document.querySelector(PAGE_SEL);
    var root =
      (page && page.closest('.shopify-section, .fcd-container, [class*="fcd"]')) ||
      document.body;
    var observer = new MutationObserver(function () {
      if (mount()) {
        observer.disconnect();
        window.clearInterval(timer);
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
